import { FC, SVGProps } from "react";

const RoundedClose: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <circle cx="14" cy="14" r="14" fill="#D6D6D6" />
      <path
        d="M14.8842 14.0001L19.8592 9.02506C20.1034 8.78089 20.1034 8.38506 19.8592 8.14089C19.6151 7.89672 19.2192 7.89672 18.9751 8.14089L14.0001 13.1159L9.02506 8.14172C8.78089 7.89756 8.38506 7.89756 8.14089 8.14172C7.89672 8.38589 7.89672 8.78172 8.14089 9.02589L13.1159 14.0009L8.14089 18.9759C7.89672 19.2201 7.89672 19.6159 8.14089 19.8601C8.26256 19.9817 8.42256 20.0434 8.58256 20.0434C8.74256 20.0434 8.90256 19.9826 9.02422 19.8601L13.9992 14.8851L18.9742 19.8601C19.0959 19.9817 19.2559 20.0434 19.4159 20.0434C19.5759 20.0434 19.7359 19.9826 19.8576 19.8601C20.1017 19.6159 20.1017 19.2201 19.8576 18.9759L14.8842 14.0001Z"
        fill="white"
      />
    </svg>
  );
};

export default RoundedClose;
